import React from 'react';
import Typography from '@mui/material/Typography';
import { CustomAccordion } from 'components/Ui/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { EmptyState, PreviousWeekNoteItem } from './SsaAtendanceTabUtils';

const PreviousWeekNoteHistory = ({ notesData, heading = 'Notes' }) => {
  const hasNotes = Array.isArray(notesData) && notesData.length > 0;

  return (
    <CustomAccordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{heading}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {hasNotes ? (
          notesData.map((item) => (
            <PreviousWeekNoteItem key={item?.id || item?.addedAt} item={item} />
          ))
        ) : (
          <EmptyState message="No attendance records found" />
        )}
      </AccordionDetails>
    </CustomAccordion>
  );
};

export default PreviousWeekNoteHistory;
